import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../../utilz';
import { getProcurementZoneListInFail, getProcurementZoneListInSuccess } from './ProcurementZoneActions';
import { getZoneListEffect } from './ProcurementZoneEffects';
import ProcurementZoneType from './ProcurementZoneTypes';

export const procurementZone = (state) => state.procurementZone;

function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmptyObjects(obj[key]);
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function* getRouteZoneListAction() {
  try {
    const { zoneListReq } = yield select(procurementZone);
    const requetParams = yield call(removeEmptyObjects, zoneListReq);
    const { data } = yield call(getZoneListEffect, requetParams);
    yield put(getProcurementZoneListInSuccess({ data: data }));
  } catch (e) {
    yield put(getProcurementZoneListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* procurementZoneSaga() {
  yield takeEvery(ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST, getRouteZoneListAction);
}
